import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface ClaimReviewValidity {
    claimApplicationId: string | null;
    randomId: string | null;
}
export interface ClaimReviewDetails extends ClaimReviewValidity {
    email: string | null;
    passCode: string | null;
}
export interface ClaimRejectedReason extends ClaimReviewDetails {
    AcceptanceStatusReason: string;
}

export interface GeneralResponse {
    data: any;
}

export const fetchClaimReviewValidity =
    createAction<fetchClaimReviewValidityAction>(
        ActionTypes.FETCH_CLAIM_REVIEW_VALIDITY,
    );
export const fetchClaimReviewValiditySuccess =
    createAction<fetchClaimReviewValiditySuccessAction>(
        ActionTypes.FETCH_CLAIM_REVIEW_VALIDITY_SUCCESS,
    );
export const fetchClaimReviewValidityFailed =
    createAction<fetchClaimReviewValidityFailedAction>(
        ActionTypes.FETCH_CLAIM_REVIEW_VALIDITY_FAILED,
    );
export const fetchClaimReviewDetails =
    createAction<fetchClaimReviewDetailsAction>(
        ActionTypes.FETCH_CLAIM_REVIEW_DETAILS,
    );
export const fetchClaimReviewDetailsSuccess =
    createAction<fetchClaimReviewDetailsSuccessAction>(
        ActionTypes.FETCH_CLAIM_REVIEW_DETAILS_SUCCESS,
    );
export const fetchClaimReviewDetailsFailed =
    createAction<fetchClaimReviewDetailsFailedAction>(
        ActionTypes.FETCH_CLAIM_REVIEW_DETAILS_FAILED,
    );
export const acceptClaimReview = createAction<acceptClaimReviewAction>(
    ActionTypes.ACCEPT_CLAIM_REVIEW,
);
export const acceptClaimReviewSuccess =
    createAction<acceptClaimReviewSuccessAction>(
        ActionTypes.ACCEPT_CLAIM_REVIEW_SUCCESS,
    );
export const acceptClaimReviewFailed =
    createAction<acceptClaimReviewFailedAction>(
        ActionTypes.ACCEPT_CLAIM_REVIEW_FAILED,
    );
export const fetchRejectionFormClaimReview =
    createAction<fetchRejectionFormClaimReviewAction>(
        ActionTypes.FETCH_REJECTION_FORM_CLAIM_REVIEW,
    );
export const fetchRejectionFormClaimReviewSuccess =
    createAction<fetchRejectionFormClaimReviewSuccessAction>(
        ActionTypes.FETCH_REJECTION_FORM_CLAIM_REVIEW_SUCCESS,
    );
export const fetchRejectionFormClaimReviewFailed =
    createAction<fetchRejectionFormClaimReviewFailedAction>(
        ActionTypes.FETCH_REJECTION_FORM_CLAIM_REVIEW_FAILED,
    );
export const rejectClaimReviewWithReason =
    createAction<rejectClaimReviewWithReasonAction>(
        ActionTypes.REJECT_CLAIM_REVIEW_WITH_REASON,
    );
export const rejectClaimReviewWithReasonSuccess =
    createAction<rejectClaimReviewWithReasonSuccessAction>(
        ActionTypes.REJECT_CLAIM_REVIEW_WITH_REASON_SUCCESS,
    );
export const rejectClaimReviewWithReasonFailed =
    createAction<rejectClaimReviewWithReasonFailedAction>(
        ActionTypes.REJECT_CLAIM_REVIEW_WITH_REASON_FAILED,
    );
export const changeClaimReviewAnswerState =
    createAction<changeClaimReviewAnswerStateAction>(
        ActionTypes.CHANGE_CLAIM_REVIEW_ANSWERS_STATE,
    );
export const changeClaimReviewState =
    createAction<changeClaimReviewStateAction>(
        ActionTypes.CHANGE_CLAIM_REVIEW_STATE,
    );

export interface fetchClaimReviewValidityAction {
    type?: typeof ActionTypes.FETCH_CLAIM_REVIEW_VALIDITY;
    claimApplicationId: string;
    randomId: string;
}
export interface fetchClaimReviewValiditySuccessAction {
    type: typeof ActionTypes.FETCH_CLAIM_REVIEW_VALIDITY_SUCCESS;
    body: GeneralResponse;
}
export interface fetchClaimReviewValidityFailedAction {
    type: typeof ActionTypes.FETCH_CLAIM_REVIEW_VALIDITY_FAILED;
    payload: GeneralResponse;
}
export interface fetchClaimReviewDetailsAction {
    type?: typeof ActionTypes.FETCH_CLAIM_REVIEW_DETAILS;
    ClaimApplicationId: string | null;
    RandomId: string | null;
    Email: string;
    Passcode: string;
    LanguageId: string | null;
}
export interface fetchClaimReviewDetailsSuccessAction {
    type: typeof ActionTypes.FETCH_CLAIM_REVIEW_DETAILS_SUCCESS;
    body: GeneralResponse;
}
export interface fetchClaimReviewDetailsFailedAction {
    type: typeof ActionTypes.FETCH_CLAIM_REVIEW_DETAILS_FAILED;
    payload: GeneralResponse;
}
export interface acceptClaimReviewAction {
    type?: typeof ActionTypes.ACCEPT_CLAIM_REVIEW;
    ClaimApplicationId: string | null;
    RandomId: string | null;
    Email: string | null;
    Passcode: string | null;
    LanguageId: string | null;
}
export interface acceptClaimReviewSuccessAction {
    type: typeof ActionTypes.ACCEPT_CLAIM_REVIEW_SUCCESS;
    body: GeneralResponse;
}
export interface acceptClaimReviewFailedAction {
    type: typeof ActionTypes.ACCEPT_CLAIM_REVIEW_FAILED;
    payload: GeneralResponse;
}

export interface fetchRejectionFormClaimReviewAction {
    type?: typeof ActionTypes.FETCH_REJECTION_FORM_CLAIM_REVIEW;
    ClaimApplicationId: string | null;
    RandomId: string | null;
    LanguageId: string | null;
}

export interface fetchRejectionFormClaimReviewSuccessAction {
    type: typeof ActionTypes.FETCH_REJECTION_FORM_CLAIM_REVIEW_SUCCESS;
    body: GeneralResponse;
}
export interface fetchRejectionFormClaimReviewFailedAction {
    type: typeof ActionTypes.FETCH_REJECTION_FORM_CLAIM_REVIEW_FAILED;
    payload: GeneralResponse;
}
export interface rejectClaimReviewWithReasonAction {
    type?: typeof ActionTypes.REJECT_CLAIM_REVIEW_WITH_REASON;
    ClaimApplicationId: string | null;
    RandomId: string | null;
    Email: string | null;
    Passcode: string | null;
    AcceptanceStatusReason: any;
    LanguageId: string | null;
}
export interface rejectClaimReviewWithReasonSuccessAction {
    type: typeof ActionTypes.REJECT_CLAIM_REVIEW_WITH_REASON_SUCCESS;
    body: GeneralResponse;
}
export interface rejectClaimReviewWithReasonFailedAction {
    type: typeof ActionTypes.REJECT_CLAIM_REVIEW_WITH_REASON_FAILED;
    payload: GeneralResponse;
}
export interface changeClaimReviewAnswerStateAction {
    type?: typeof ActionTypes.CHANGE_CLAIM_REVIEW_ANSWERS_STATE;
    email?: string | null;
    passCode?: string | null;
    claimApplicationId?: string | null;
    randomId?: string | null;
}
export interface changeClaimReviewStateAction {
    type?: typeof ActionTypes.CHANGE_CLAIM_REVIEW_STATE;
    rejectedReasonClaimReview: string | null;
}
